import { defineMessages } from 'react-intl';

export const messages: {
	closeModal: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	ctaNoPaymentDetailsOnFile: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	ctaRequestTrialText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	ctaWithPaymentDetailsOnFile: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionConfluence: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionJira: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionLoomPremium: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionLoomStandard: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionRovo: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	existingAppsHeader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	headingAIPowered: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	headingConfluenceOnly: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	headingDocs: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	headingJiraAndLoom: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	headingJiraOnly: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	headingNoPriceIncrease: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	headingNoPriceIncreaseEmphasis: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	headingPriceIncrease: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	headingPriceIncreaseEmphasis: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	headingVideo: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	priceChangeDecrease: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	priceChangeSame: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	requestTrialComment: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	requestTrialText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	teamworkCollectionAlt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	trialTextPremiumNoPriceIncrease: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	trialTextPremiumPriceIncrease: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	trialTextStandardNoPriceIncrease: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	trialTextStandardPriceIncrease: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	visualAlt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	headingNoPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.no.price.increase',
		defaultMessage: 'Accelerate teamwork 3× faster with video and AI, at {headingEmphasis}',
		description:
			'Header text for teamwork collection crossflow modal. The headingEmphasis placeholder is originally "no added cost"',
	},
	headingNoPriceIncreaseEmphasis: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.no.price.increase.emphasis.ai.powered',
		defaultMessage: 'no added cost',
		description: 'Emphasized text inside of the header when there is no price increase',
	},
	headingPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.price.increase',
		defaultMessage: 'Accelerate teamwork {headingEmphasis} with {break}',
		description:
			'Default header text for teamwork collection crossflow modal when there is a price increase. The break placeholder originally says "video and AI-powered collaboration".',
	},
	headingJiraOnly: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.jira.only',
		defaultMessage: 'Accelerate teamwork {headingEmphasis} with {break}',
		description:
			'Header text for teamwork collection crossflow modal when there is a price increase and the tenant has only Jira. The break placeholder originally says "AI-powered collaboration".',
	},
	headingConfluenceOnly: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.confluence.only',
		defaultMessage: 'Accelerate teamwork {headingEmphasis} with {break}',
		description:
			'Header text for teamwork collection crossflow modal when there is a price increase and the tenant has only Confluence. The break placeholder originally says "AI-powered collaboration".',
	},
	headingJiraAndLoom: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.jira.and.loom',
		defaultMessage: 'Accelerate teamwork {headingEmphasis} with {break}',
		description:
			'Header text for teamwork collection crossflow modal when there is a price increase and the tenant has Jira and Loom. The break placeholder originally says "docs and AI-powered collaboration".',
	},
	headingPriceIncreaseEmphasis: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.price.increase.emphasis',
		defaultMessage: '3× faster',
		description: 'Emphasized text inside of the header when there is a price increase',
	},
	headingAIPowered: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.ai.powered',
		defaultMessage: 'AI-powered collaboration',
		description: 'Text segment used to break up the Jira-only heading text',
	},
	headingVideo: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.video',
		defaultMessage: 'video and AI-powered collaboration',
		description: 'Text segment used to break up the default heading text',
	},
	headingDocs: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.docs',
		defaultMessage: 'docs and AI-powered collaboration',
		description: 'Text segment used to break up the Jira and Loom heading text',
	},
	closeModal: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.close',
		defaultMessage: 'Close modal',
		description: 'Label for the button to close the modal dialog',
	},
	teamworkCollectionAlt: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.alt',
		defaultMessage: 'Teamwork collection illustration',
		description: 'Alternative text for the teamwork collection illustration image',
	},
	ctaWithPaymentDetailsOnFile: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.ctaWithPaymentDetailsOnFile',
		defaultMessage: 'Agree and start trial',
		description: 'Confirmation button label when payment details are already on file',
	},
	ctaNoPaymentDetailsOnFile: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.ctaNoPaymentDetailsOnFile',
		defaultMessage: 'Next',
		description: 'Confirmation button label when no payment details are on file yet',
	},
	trialTextStandardNoPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.standard.noPriceIncrease',
		defaultMessage: '14-day free trial. After, your cost will {priceChange}.',
		description:
			'Subheading when opting into a Standard trial plan when there is no price increase',
	},
	trialTextPremiumNoPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.premium.noPriceIncrease',
		defaultMessage: '30-day free trial. After, your cost will {priceChange}.',
		description: 'Subheading when opting into a Premium trial plan when there is no price increase',
	},
	priceChangeSame: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.noPriceIncrease.same',
		defaultMessage: 'stay the same',
		description:
			'Text inside of the subheading for no price change when the price change is neutral',
	},
	priceChangeDecrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.noPriceIncrease.decrease',
		defaultMessage: 'decrease',
		description:
			'Text inside of the subheading for no price change when the price change is a decrease',
	},
	trialTextStandardPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.standard.priceIncrease',
		defaultMessage: '14-day free trial of Standard plan',
		description: 'Subheading when opting into a Standard trial plan when there is a price increase',
	},
	requestTrialText: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.request.trial',
		defaultMessage: 'Request approval from your admin to try Teamwork Collection',
		description: 'Subheading text shown to non-admin users requesting a trial',
	},
	ctaRequestTrialText: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.cta.request.trial',
		defaultMessage: 'Request to try',
		description: 'Button text shown to non-admin users to request a trial access',
	},
	requestTrialComment: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.request.trial.comment',
		defaultMessage:
			'Teamwork Collection brings together Jira, Confluence, Loom, and Rovo so you can plan, document, and collaborate across teams—all in one place.',
		description: 'Trial request notification text sent to the admin for approval',
	},
	trialTextPremiumPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.premium.priceIncrease',
		defaultMessage: '30-day free trial of Premium plan',
		description: 'Subheading when opting into a Premium trial plan when there is a price increase',
	},
	descriptionConfluence: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.confluence',
		defaultMessage: 'Create and collaborate on docs seamlessly',
		description: 'Description of the Confluence product and its capabilities',
	},
	descriptionJira: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.jira',
		defaultMessage: 'Plan and track work with your team and agents',
		description: 'Description of the Jira product and its capabilities',
	},
	descriptionRovo: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.rovo',
		defaultMessage: 'Easily find answers and create with AI',
		description: 'Description of the Rovo product and its capabilities',
	},
	descriptionLoomStandard: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.standard.loom',
		defaultMessage: 'Save time by sharing videos your team can replay anytime',
		description: 'Description of the Loom product and its capabilities',
	},
	descriptionLoomPremium: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.premium.loom',
		defaultMessage: 'Save time with AI-generated meeting notes and video',
		description: 'Description of the Loom premium product and its capabilities',
	},
	existingAppsHeader: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.existing.apps.header',
		defaultMessage: 'Bundled with your existing {appCount, plural, one {app} other {apps}}',
		description: 'Header text above the list of existing bundled apps',
	},
	visualAlt: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.visual.alt',
		defaultMessage: 'A graphic that displays Jira, Confluence, Confluence, and Loom integrations',
		description: 'Alternate text describing the bundled apps integration graphic',
	},
});
